import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";

const fmt = (iso) => iso.slice(0, 10);
const lordColor = {
  Sun: "#D4AF37", Moon: "#E6E1D6", Mars: "#C15C3D", Mercury: "#7B906F",
  Jupiter: "#E5C158", Venus: "#A8896C", Saturn: "#6E6B64",
  Rahu: "#4A5060", Ketu: "#8B7355",
};

/**
 * Flatten dasha tree into a list respecting expanded state.
 * Each expanded state is keyed by "path".
 */
function flatten(nodes, parentPath, depth, expanded, out) {
  nodes.forEach((n, i) => {
    const path = `${parentPath}/${n.level}-${n.lord}-${i}`;
    const has = n.children && n.children.length > 0;
    out.push({ node: n, depth, path, has, open: !!expanded[path] });
    if (has && expanded[path]) {
      flatten(n.children, path, depth + 1, expanded, out);
    }
  });
}

export default function DashaTimeline({ dasha }) {
  const [expanded, setExpanded] = useState({});
  if (!dasha) return null;

  const rows = [];
  flatten(dasha, "", 0, expanded, rows);

  const toggle = (path) => setExpanded((e) => ({ ...e, [path]: !e[path] }));

  return (
    <div className="border border-[#2A2D35] bg-[#181A1F] p-4 max-h-[70vh] overflow-y-auto">
      <div className="text-xs uppercase tracking-widest text-[#D4AF37] font-mono mb-3">
        Vimshottari Dasha — 5 Levels (Maha → Antar → Pratyantar → Sookshma → Prana)
      </div>
      {rows.map((r) => (
        <div
          key={r.path}
          style={{ paddingLeft: `${r.depth * 14}px` }}
          className={`flex items-center gap-2 py-1.5 border-b border-[#2A2D35]/50 ${r.has ? "cursor-pointer" : ""} hover:bg-[#0F1115]/50 transition-colors duration-150`}
          onClick={() => r.has && toggle(r.path)}
          data-testid={`dasha-${r.node.level}-${r.node.lord}-${r.node.start.slice(0, 10)}`}
        >
          {r.has
            ? (r.open
                ? <ChevronDown size={12} className="text-[#6E6B64]" />
                : <ChevronRight size={12} className="text-[#6E6B64]" />)
            : <span className="w-3" />}
          <span
            className="font-heading text-sm w-28"
            style={{ color: lordColor[r.node.lord] || "#E6E1D6" }}
          >
            {r.node.lord}{" "}
            <span className="text-[10px] text-[#6E6B64]">L{r.node.level}</span>
          </span>
          <span className="font-mono text-xs text-[#A19E95]">{fmt(r.node.start)}</span>
          <span className="text-[#6E6B64]">→</span>
          <span className="font-mono text-xs text-[#A19E95]">{fmt(r.node.end)}</span>
        </div>
      ))}
    </div>
  );
}
